const BAND_PAGE_BASE = "/band/:bandId";
const COMPANY_PAGE_BASE = "/company/:companyId";

export const BAND_PATHS = {
  HOME: "/",
  // Profile
  PROFILE: "/profile",
  EDIT_PROFILE: "/profile/edit",
  EDIT_PROFILE_CONTACT: "/profile/edit/contact",
  EDIT_PROFILE_DOCUMENTS: "/profile/edit/documents",
  EDIT_PROFILE_PREFERENCES: "/profile/edit/preferences",
  CALENDAR: "/calendar",
  ADMIN: "/admin",
  ADMIN_DASHBOARD: "/admin/dashboard",
  ADMIN_BAND: "/admin/band/:bandId",
  MY_VENUES: "/my-venues",
  _EVENT_DETAILS_EXPORT: "/_event-details-export/:id",
  // Company
  COMPANY: COMPANY_PAGE_BASE,
  COMPANY_DASHBOARD: `${COMPANY_PAGE_BASE}/dashboard`,
  COMPANY_INFO: `${COMPANY_PAGE_BASE}/info`,
  EDIT_COMPANY_INFO: `${COMPANY_PAGE_BASE}/info/edit`,
  COMPANY_PAYMENT_SUCCESS: `${COMPANY_PAGE_BASE}/success/:type`,
  COMPANY_PAYMENT_ERROR: `${COMPANY_PAGE_BASE}/error/:type`,
  // Band: Calendar
  BAND_CALENDAR: `${BAND_PAGE_BASE}/calendar`,
  // Band: Create
  CREATE_BAND: "/band/create",
  // Band: Event
  CREATE_BAND_EVENT: `${BAND_PAGE_BASE}/event/create`,
  BAND_EVENT: `${BAND_PAGE_BASE}/event/:eventId`,
  EDIT_BAND_EVENT: `${BAND_PAGE_BASE}/event/:eventId/edit`,
  CREATE_PEOPLE_BLOCK: `${BAND_PAGE_BASE}/event/:eventId/people/create`,
  EDIT_PEOPLE_BLOCK: `${BAND_PAGE_BASE}/event/:eventId/people/:blockId/edit`,
  CREATE_SCHEDULE_BLOCK: `${BAND_PAGE_BASE}/event/:eventId/schedule/create`,
  EDIT_SCHEDULE_BLOCK: `${BAND_PAGE_BASE}/event/:eventId/schedule/:blockId/edit`,
  CREATE_INFO_BLOCK: `${BAND_PAGE_BASE}/event/:eventId/infoBlock/:blockTypeId/create`,
  EDIT_INFO_BLOCK: `${BAND_PAGE_BASE}/event/:eventId/infoBlock/:blockTypeId/:blockId/edit`,
  CREATE_VENUE_BLOCK: `${BAND_PAGE_BASE}/event/:eventId/venue/create`,
  EDIT_VENUE_BLOCK: `${BAND_PAGE_BASE}/event/:eventId/venue/:blockId/edit`,
  CREATE_GUESTLIST_BLOCK: `${BAND_PAGE_BASE}/event/:eventId/guestlist/create`,
  EDIT_GUESTLIST_BLOCK: `${BAND_PAGE_BASE}/event/:eventId/guestlist/:blockId/edit`,
  CREATE_TRAVEL_BLOCK: `${BAND_PAGE_BASE}/event/:eventId/travel/create`,
  EDIT_TRAVEL_BLOCK: `${BAND_PAGE_BASE}/event/:eventId/travel/:blockId/edit`,
  CREATE_ACCOMMODATION_BLOCK: `${BAND_PAGE_BASE}/event/:eventId/accommodation/create`,
  EDIT_ACCOMMODATION_BLOCK: `${BAND_PAGE_BASE}/event/:eventId/accommodation/:blockId/edit`,
  // Band: Settings
  BAND_SETTINGS: `${BAND_PAGE_BASE}/settings`,
  EDIT_BAND_SETTINGS_REGIONAL: `${BAND_PAGE_BASE}/settings/edit/regional`,
  EDIT_BAND_SETTINGS_EVENT: `${BAND_PAGE_BASE}/settings/edit/event`,
  EDIT_BAND_SETTINGS_MEMBER: `${BAND_PAGE_BASE}/settings/edit/member`,
  // Band: Subscription
  SUBSCRIPTION: `${BAND_PAGE_BASE}/subscription`,
  SUBSCRIPTION_OVERVIEW: `${BAND_PAGE_BASE}/subscription/plan`,
  SUBSCRIPTION_BILLING_INFO: `${BAND_PAGE_BASE}/subscription/billing-info`,
  SUBSCRIPTION_SUCCESS: `${BAND_PAGE_BASE}/subscription/success`,
  SUBSCRIPTION_ERROR: `${BAND_PAGE_BASE}/subscription/error`,
  SUBSCRIPTION_PENDING: `${BAND_PAGE_BASE}/subscription/pending`,
  EDIT_SUBSCRIPTION_COMPANY: `${BAND_PAGE_BASE}/subscription/billing-info/edit`,
  EDIT_SUBSCRIPTION_PLAN: `${BAND_PAGE_BASE}/subscription/plan/edit`,
  // Band: Members
  MEMBERS: `${BAND_PAGE_BASE}/members`,
  CREATE_MEMBER: `${BAND_PAGE_BASE}/members/create`,
  EDIT_INVITATION: `${BAND_PAGE_BASE}/members/invitation/:invitationId/edit`,
  ACCEPT_INVITATION: "/join-band",
  ANSWER_RSVP: "/answer-rsvp",
  EDIT_MEMBER: `${BAND_PAGE_BASE}/members/:userId/edit`,
  VIEW_MEMBER: `${BAND_PAGE_BASE}/members/:userId`,
  PERMISSIONS: `${BAND_PAGE_BASE}/members/permissions`,
  PERMISSION_GROUP: `${BAND_PAGE_BASE}/members/permissions/:groupId`,
  EDIT_PERMISSION: `${BAND_PAGE_BASE}/members/permissions/user/:userId`,
  // Band: Assets
  BAND_ASSETS: `${BAND_PAGE_BASE}/assets`,
  BAND_ASSETS_CONTACTS: `${BAND_PAGE_BASE}/assets/contacts`,
  BAND_ASSETS_PLACES: `${BAND_PAGE_BASE}/assets/places`,
};
